import { shell } from '../../shell/shellClasses';
import type { OverlayMetricDef, OverlayMetricId } from './types';

export function MetricToggleBar({
  metrics,
  enabled,
  onToggle,
}: {
  metrics: OverlayMetricDef[];
  enabled: Set<OverlayMetricId>;
  onToggle: (id: OverlayMetricId) => void;
}) {
  return (
    <div
      role="group"
      aria-label="Overlay metrics"
      className="flex flex-wrap gap-2"
    >
      {metrics.map((m) => {
        const on = enabled.has(m.id);
        const disabled = !m.available;
        return (
          <button
            key={m.id}
            type="button"
            disabled={disabled}
            title={disabled ? m.disabledReason : `${on ? 'Hide' : 'Show'} ${m.label}`}
            aria-pressed={on}
            aria-disabled={disabled}
            onClick={() => onToggle(m.id)}
            className={`inline-flex min-h-11 items-center gap-2 rounded-[var(--shell-radius-md)] border px-2.5 text-xs font-medium transition-colors duration-[var(--shell-motion-fast)] ${shell.focusRing} ${
              disabled
                ? 'cursor-not-allowed border-[var(--shell-border)] opacity-45'
                : on
                  ? 'border-[var(--shell-border)] bg-[var(--shell-hover)] text-[var(--shell-fg)]'
                  : `${shell.border} ${shell.surfaceElevated} ${shell.muted}`
            }`}
          >
            <span
              className="h-2.5 w-2.5 shrink-0 rounded-full"
              style={{ background: disabled ? 'var(--shell-fg-subtle)' : m.color }}
              aria-hidden
            />
            <span>{m.label}</span>
            {disabled && <span className={shell.subtle}>Unavailable</span>}
          </button>
        );
      })}
    </div>
  );
}
